// extracted by css-extract-rspack-plugin
export default {"popover":"CollapsibleNavList-module__popover__F8tjH","trigger":"CollapsibleNavList-module__trigger__SH0G6"};